'use client';

import { useResetPassword } from '@/modules/authentication/application';

import { useToast } from '@packages/web-design-systems';

import { mapResetPasswordFormToDto } from '../mappers';
import type { ResetPasswordFormModel } from '../models/reset-password.form-model';

export const useResetPasswordForm = () => {
	const { submit } = useResetPassword();
	const { showError, showSuccess } = useToast();

	const execute = async (form: ResetPasswordFormModel) => {
		const dto = mapResetPasswordFormToDto(form);
		const result = await submit(dto);

		return result.isFailure
			? showError({ title: 'Password reset failed' })
			: showSuccess({ title: 'Password reset successful' });
	};

	return { execute };
};
